import { FC, SVGProps } from 'react'

const SaveIcon: FC<SVGProps<SVGSVGElement>> = svgProps => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M2.19531 14.5H12.1953C13.2999 14.5 14.1953 13.6046 14.1953 12.5V4.7027C14.1953 4.25233 14.0433 3.81513 13.7639 3.46191L12.0215 1.25921C11.6422 0.779676 11.0643 0.5 10.4529 0.5H2.19531C1.09074 0.5 0.195312 1.39543 0.195312 2.5V12.5C0.195312 13.6046 1.09074 14.5 2.19531 14.5Z"
        fill="currentColor"
      />
      <ellipse cx="6.98337" cy="11.3851" rx="2.20212" ry="2.29009" fill="white" />
      <path
        d="M1.6875 3.45587C1.6875 2.60341 2.37856 1.91235 3.23102 1.91235H7.63564C8.4881 1.91235 9.17916 2.60341 9.17916 3.45587V3.50857C9.17916 4.36103 8.4881 5.05209 7.63564 5.05209H3.23102C2.37856 5.05209 1.6875 4.36103 1.6875 3.50857V3.45587Z"
        fill="white"
      />
    </svg>
  )
}

export default SaveIcon
